import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Cart from "./Pages/Cart";

function App() {
  return (
   <div>
    <div className=" bg-slate-900 ">
        <Navbar/>
    </div>
     <Routes>
      <Route path="/" element={<Home/>}></Route>
      <Route path="/cart" element={<Cart/>}></Route>
     </Routes>

   </div>
  );
}

export default App;
